import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _, { isEqual } from 'lodash';

import GenerateActivationKey from './components/GenerateActivationKey';
import ActivationKeyTable from './components/ActivationKeyTable';
import ViewActivationKey from './components/ViewActivationKey';
import {
  generateActivationKey,
  getAccountActiovationKeys,
} from '../../../../actions/activationKeyActions';
import { toastError } from '../../../../util/toastUtils';

const AccountActivationKey = props => {
  const [activeRoles, setActiveRoles] = useState([]);
  const [activeEntitlements, setActiveEntitlements] = useState([]);
  const [activeRolesCopy, setActiveRolesCopy] = useState([]);
  const [activeEntitlementsCopy, setActiveEntitlementsCopy] = useState([]);
  const [activationKeys, setActivationKeys] = useState([]);
  const [selectedKey, setSelectedKey] = useState({});
  const [isDataChanged, setIsDataChanged] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [activationKey, setActivationKey] = useState('');
  const [checkBoxSelected, setCheckBoxSelected] = useState("N");

  useEffect(() => {
    getAccountActiovationKeys(props.accountDetail.publicId).then(res => {
      if (res && res.error) {
        toastError(res.error);
      } else {
        setActivationKeys(res.data ? res.data : []);
      }
    });
  }, []);
  useEffect(() => {
    const isDirty =
      isEqual(activeRoles, activeRolesCopy) &&
      isEqual(activeEntitlementsCopy, activeEntitlements);
    setIsDataChanged(isDirty);
  }, [
    activeRolesCopy,
    activeEntitlementsCopy,
    activeRoles,
    activeEntitlements,
  ]);

  const openActivationKeyDetails = key => {
    setError('');
    setSuccessMessage('');
    setActivationKey('');
    setCheckBoxSelected('N');
    if (key) {
      const keySelected = activationKeys.find(
        data => data.activationKey === key.activationKey
      );
      setActiveRoles(keySelected.roles);
      setActiveEntitlements(keySelected.entitlements);
      setSelectedKey(keySelected);
      props.setActivePage('DETAIL');
    } else {
      setActiveRoles([]);
      setActiveEntitlements([]);
      setActiveRolesCopy([]);
      setActiveEntitlementsCopy([]);
      props.setActivePage('CREATE');
    }
  };

  const backToActivationKeyTable = () => {
    setActiveRoles([]);
    setActiveEntitlements([]);
    setError('');
    setSuccessMessage('');
    setActivationKey('');
    props.setActivePage('ACTIVATION KEY');
  };

  const mapRequest = () => {
    const data = {
      publicId: props.accountDetail.publicId,
      isAddSubscriptions: checkBoxSelected,
      roles: activeRoles,
      entitlements: activeEntitlements,
    };
    return data;
  };

  const generateKey = () => {
    const data = mapRequest();
    setSuccessMessage('');
    setError('');
    setActivationKey('');
    generateActivationKey(data).then(res => {
      setActiveRolesCopy(activeRoles);
      setActiveEntitlementsCopy(activeEntitlements);
      if (res.data.status !== 200) {
        setError(res.data.error);
        // setNewActivationKey(res,data.newActivationKey);
      } else {
        setSuccessMessage(res.data.message);
        // setNewActivationKey(res,data.newActivationKey);
        setActivationKeys(res.data.data);
      }
      setActivationKey(res.data.activationKey);
    });
  };

  const _handleOnChange = (event) => {
    const selectedValue = (event.target.checked)? "Y" : "N";
    setCheckBoxSelected(selectedValue);
  };
  
  const renderContent = () => {
    const { activePage } = props;
    const users = _.isEmpty(props.accountDetail.users)
      ? []
      : _.sortBy(props.accountDetail.users, o => o.firstName);

    const accountDetail = {
      ...props.accountDetail,
      users,
    };
    const isTPPAccount = accountDetail.accountType === 'TPP';

    let message = (
      <React.Fragment>
        There are no Activation Key currently generated to this account. Please
        click on <strong>Generate New Key</strong> above to Generate Activation
        Key.
      </React.Fragment>
    );

    if (isTPPAccount) {
      message = (
        <React.Fragment>
          Activation Key cannot be created or associated to a Third Party
          Account.
        </React.Fragment>
      );
    }

    if (activePage === 'ACTIVATION KEY') {
      return (
        <div className="accounts-roles-listing">
          <div className="accounts-roles-header">
            <button
              disabled={isTPPAccount || !props.hasAccess}
              style={{ opacity: isTPPAccount || !props.hasAccess ? 0.5 : 1 }}
              onClick={() => openActivationKeyDetails()}
              className="accounts-details-card-button"
              type="button"
            >
              <span>Generate New Key</span>
            </button>
          </div>
          {!activationKeys.length || isTPPAccount ? (
            <div className="no-result-message">{message}</div>
          ) : (
            <ActivationKeyTable
              accountDetail={accountDetail}
              activationKeys={activationKeys}
              openActivationKeyDetails={openActivationKeyDetails}
            />
          )}
        </div>
      );
    }
    if (activePage === 'CREATE' && !isTPPAccount) {
      return (
        <GenerateActivationKey
          availableRoles={accountDetail.roles.filter(
            data => data.activeStatus === 'Y'
          )}
          activeRoles={activeRoles}
          setActiveRoles={setActiveRoles}
          setActiveEntitlements={setActiveEntitlements}
          handleBack={backToActivationKeyTable}
          accountDetail={accountDetail}
          availableEntitlements={accountDetail.entitlements}
          activeEntitlements={activeEntitlements}
          updatedActivePage={props.updatedActivePage}
          hasAccess={props.hasAccess}
          generateKey={generateKey}
          isDataChanged={isDataChanged}
          error={error}
          successMessage={successMessage}
          activationKey={activationKey}
	        handleOnChange={_handleOnChange}
	        successIsAddSubscriptions={checkBoxSelected}
        />
      );
    }
    if (activePage === 'DETAIL' && !isTPPAccount) {
      return (
        <ViewActivationKey
          availableRoles={accountDetail.roles}
          selectedKey={selectedKey}
          activeRoles={activeRoles}
          setActiveRoles={setActiveRoles}
          setActiveEntitlements={setActiveEntitlements}
          handleBack={backToActivationKeyTable}
          accountDetail={accountDetail}
          availableEntitlements={accountDetail.entitlements}
          activeEntitlements={activeEntitlements}
          updatedActivePage={props.updatedActivePage}
          hasAccess={props.hasAccess}
        />
      );
    }
    return null;
  };

  return <div className="accounts-roles">{renderContent()}</div>;
};
AccountActivationKey.defaultProps = {
  activePage: 'ACTIVATION KEY',
  accountDetail: {},
  hasAccess: 0,
};
AccountActivationKey.propTypes = {
  accountDetail: PropTypes.instanceOf(Object),
  setActivePage: PropTypes.func,
  activePage: PropTypes.string,
  updatedActivePage: PropTypes.func,
  hasAccess: PropTypes.bool,
  successIsAddSubscriptions: PropTypes.string,
};
export default AccountActivationKey;
